import { createContext, useContext } from "react"

// Beside NotifierProvider rather than in it: a module exporting a component may export nothing
// else, or Vite's Fast Refresh gives up on the whole file.

/**
 * Shows a toast-style notification. `title` is the emphasized headline; `message` is the
 * optional supporting line beneath it.
 *
 * - Frontend: uses the Ember Notifier service. We can't use sonner yet because
 * there is nowhere to mount a single global Toaster.
 * - Instructional Hub: TODO
 */
export type NotifierFunction = (
  type: "success" | "warning" | "error",
  title: string,
  message?: string,
) => void

export const NotifierContext = createContext<NotifierFunction | null>(null)

/** Access the host's {@link NotifierFunction}. Returns a no-op fallback when outside a NotifierProvider. */
export function useNotifier(): NotifierFunction {
  const notifier = useContext(NotifierContext)
  return notifier ?? (() => {})
}
